<script lang="ts">
import type { HTMLAttributes } from "vue"
import { vAutoAnimate } from "@formkit/auto-animate/vue"
import { useId } from "radix-vue"
import { provide } from "vue"
import { useClass } from "~/composables/local/cn-class"
import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys"
</script>

<script lang="ts" setup>
const props = defineProps<{
	class?: HTMLAttributes["class"]
}>()

const className = useClass(
	"gap-y-2 grid",
	() => props.class,
)

const id = useId()
provide(FORM_ITEM_INJECTION_KEY, id)
</script>

<template>
	<div
		v-auto-animate
		:class="className">
		<slot />
	</div>
</template>
